export const DURATION_CONFIG = {
  GROUP_DURATION_TOOLTIP_CONTAINER: 'group-duration-tooltip-container',
  GROUP_DURATION_CHANGE_BUTTON: 'group-duration-change-button'
} as const;
